// For IE11 support
import { enableES5 } from 'immer';
enableES5();

import produce from 'immer';
import { TICKET_MGMT_TYPES } from '@constants/actionTypes/ticketMgmtActionTypes';

export const INITIAL_STATE = {
    loaded: false,
    activeCategory: '',
    entities: [],
    searchedTktCategoriesAndTypeList: [],
    
};

export default produce((draft = INITIAL_STATE, action = {}) => {
    switch (action.type) {
        case TICKET_MGMT_TYPES.GET_CATEGORIES:
            draft.loaded = true;
            draft.entities = action.data;
            break;
        case TICKET_MGMT_TYPES.GET_CATEGORIES_BY_STATUS:
            draft.entities = action.data;
            break;
        case TICKET_MGMT_TYPES.SEARCH_TICKET_CATEGORIES_AND_TYPES:
            draft.searchTktCategoriesAndTypeResults = action.workflowsByCategory;
            break;
        case TICKET_MGMT_TYPES.EMPTY_SEARCH_RESULTS:
            draft.searchTktCategoriesAndTypeResults = action.workflowsByCategory;
            break;
        case TICKET_MGMT_TYPES.SELECT_CATEGORY:
            draft.activeCategory = action.activeCategory;
            break;

        case TICKET_MGMT_TYPES.RENAME_CATEGORY: {
            const { oldCategory, category , categoryEs } = action;
            draft.activeCategory = { 'ticketCategory': category, 'ticketCategorySpanishName':categoryEs };
            draft.entities = Object.fromEntries(
                Object.entries(draft.entities)
                    .map(([entity, value]) => {
                        if(entity === oldCategory){
                            return  [category, categoryEs];
                        }
                        return  [entity, value];
                    }),
            );
            break;
        }

        default:
            return draft;
    }
});